<div
  class="rs-panel-big rs-bg-c2"
  *ngFor="let aProductSplit of filteredProductSplit; index as productSplitIndex"
>
  <div
    my-bill-odb-product-split-identifier
    *ngIf="aProductSplit.identifier"
    [identifier]="aProductSplit.identifier"
    [category]="category"
    [divisionType]="divisionType"
  ></div>
  <my-bill-odb-category-details
    *ngIf="aProductSplit?.categoryDetails"
    [categoryDetails]="aProductSplit.categoryDetails"
    [billingAccountNumber]="billingAccountNumber"
    [productSplitIdentifier]="aProductSplit.identifier"
    [documentReference]="documentReference"
    [category]="category"
  ></my-bill-odb-category-details>

  <div
    my-bill-odb-sub-total
    [amount]="aProductSplit.amount"
    *ngIf="aProductSplit.amount && showSubTotals"
  ></div>
</div>

<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="totalAmount"
  *ngIf="filteredProductSplit.length === productSplit.length"
></div>
